import { withStyles } from '@material-ui/core/styles';
import BopsAddress from './BopsAddress';
import styles from './BopsAddress.styles';

export default withStyles(styles)(BopsAddress);
